import React, { useEffect, useState } from "react";
import "./subadmineditform.css";
// eslint-disable-next-line
import PersonIcon from "@mui/icons-material/Person";
// eslint-disable-next-line
import { KeyboardArrowDownSharp,KeyboardArrowUpSharp,
} from "@mui/icons-material";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import CircularProgress from "@mui/material/CircularProgress";
import { isValuePresent } from "../../../utils";
import { Checkbox, FormControl, ListItemText } from "@mui/material";
import avatars from "../../Global/avtar";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function SubAdminEditForm({ data, edit2 }) {
  const [name, setName] = useState(data?.name);
  const [role, setRole] = useState(data.permissions);
  const [Password, setPassword] = useState("");
  const [img, setImg] = useState("");
  // eslint-disable-next-line
  const [imagediv, setImagediv] = useState(true);
  // eslint-disable-next-line
  const [up, setUp] = useState(false);
  // eslint-disable-next-line
  const [down, setDown] = useState(false);
  const [IsTrue, setIstrue] = useState(true);
  // eslint-disable-next-line
  const [loader, setLoder] = useState(false);
  const [email, setEmail] = useState(data.email);
  const requiredFields = [name, img, email, role, Password];
  const [active, setActive] = useState(edit2);
  const dataname = [
    { id: 1, key: "CONSULTANT" },
    { id: 2, key: "USER" },
    { id: 3, key: "LANGUAGE" },
    { id: 4, key: "SERVICE" },
    { id: 5, key: "EXPERTISE" },
    { id: 6, key: "RECHARGE" },
    { id: 7, key: "CONSULTANT_RECORDINGS" },
    { id: 8, key: "CREDENTIALS" },
    { id: 9, key: "BANK_ACCOUNTS" },
    { id: 10, key: "TRANSFER_FUNDS" },
  ];

  const submit = async (e) => {
    e.preventDefault();
    if (active === true) {
      setActive(true);
    } else {
      //use api
    }
  };

  useEffect(() => {
    setImg(avatars[0].image);
  }, []);

  useEffect(() => {
    const isAllFilled = requiredFields.some((field) => !isValuePresent(field));
    setIstrue(isAllFilled);
  }, [...requiredFields]);

  const remove = (e) => {
    e.preventDefault();
    setIstrue(true);
    setUp(false);
    setDown(false);
    setImagediv(true);
    setName("");
    setPassword("");
    setEmail("");
  };
  // eslint-disable-next-line
  const handleDropdown = () => {
    setDown((prev) => !prev);
    setUp((prev) => !prev);
  };

  return (
    <div className="form2">
      {!loader ? (
        <div className="form2">
          <form onSubmit={submit} action="">
            <div className="input-type">
              <h3>
                Name <sup>*</sup>
              </h3>
              <input
                type="text"
                placeholder="Enter Your Name"
                required
                value={name}
                style={{
                  width: "100%",
                  cursor: active && "not-allowed",
                }}
                onChange={(e) => {
                  setName(e.target.value);
                }}
                disabled={active}
              />
            </div>
            <div className="location">
              <h2> Admin Permissions</h2>
              <div className="field">
                <div className="subfield">
                  <FormControl>
                    <label htmlFor="Select expertise">
                      <h3>
                        Choose Permissions <sup>*</sup>
                      </h3>
                    </label>
                    <Select
                      multiple
                      required
                      className="userservice"
                      displayEmpty
                      value={role}
                      onChange={(e) => {
                        setRole(e.target.value);
                      }}
                      renderValue={(select) => {
                        if (select.length === 0) {
                          return "Choose Permissions";
                        }

                        const Permissions = dataname
                          .filter((data) => select.includes(data.key))
                          .map((data) => data.key)
                          .join(",");

                        return Permissions;
                      }}
                      MenuProps={MenuProps}
                      style={{
                        background: "white",
                        boxShadow: "none",
                        border: "0.9px solid #1c1c1c1f",
                        borderRadius: "5px",
                        color: "#1c1c1cc8",
                        width: "100%",
                        cursor: active && "not-allowed",
                      }}
                      disabled={active}
                    >
                      {dataname.map((items) => (
                        <MenuItem key={items} value={items.key}>
                          <Checkbox checked={role.includes(items.key)} />
                          <ListItemText primary={items.key} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </div>
            </div>
            <div
              className="mincont"
              style={{ display: "flex", gap: "10px", width: "100%" }}
            >
              {/* <div className="input-type">
                <h3>Password <sup>*</sup></h3>
                <input 
                   type='text' 
                   placeholder='Enter Your Password'  
                   value={Password}  
                   onChange={handlePassword} 
                   minLength='8' 
                   style={{width:'100%'}}
                />
            </div> */}
              <div className="input-type">
                <h3>
                  Email <sup>*</sup>
                </h3>
                <input
                  type="email"
                  placeholder="Enter Email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  style={{
                    width: "100%",
                    cursor: active && "not-allowed",
                  }}
                  required
                  disabled={active}
                />
              </div>
            </div>
            <div className="submit">
              <div>
                {!active && (
                  <button
                    className="button-discard"
                    onClick={remove}
                    style={{
                      outline: IsTrue ? "none" : " 1px solid #F99234",
                      color: IsTrue ? "#1c1c1c6d" : "#F99234",
                      background: IsTrue ? "rgba(63, 61, 61, 0.07)" : "#FFFFFF",
                    }}
                    type="button"
                  >
                    DISCARD EDIT
                  </button>
                )}
                <button
                  className="button-edit"
                  style={{
                    outline: active ? "none" : " 1px solid #F99234",
                    color: active ? "#1c1c1c6d" : "#FFFF",
                    background: active ? "rgba(63, 61, 61, 0.07)" : "#F99234",
                  }}
                  disabled={active}
                  type="submit"
                >
                  {active ? "EDIT" : "SAVE CHANGES"}
                </button>
              </div>
            </div>
          </form>
        </div>
      ) : (
        <div className="loader">
          <CircularProgress style={{ color: "#F99234" }} />
        </div>
      )}
    </div>
  );
}
